var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-result',{attrs:{"icon":"success","title":"成功提示","subTitle":"请根据提示进行操作"}})
}
var staticRenderFns = []

export { render, staticRenderFns }